// Leave requests (docs/leave.md). Faculty now; students later (same shapes).

export type LeaveApplicantType = "FACULTY" | "STUDENT";
export type LeaveHalfDay = "FIRST_HALF" | "SECOND_HALF";
export type LeaveType = "CASUAL" | "SICK" | "OTHER";
export type LeaveStatus = "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";

export const LEAVE_TYPES: { value: LeaveType; label: string }[] = [
  { value: "CASUAL", label: "Casual" },
  { value: "SICK", label: "Sick" },
  { value: "OTHER", label: "Other" },
];

// Dates are "YYYY-MM-DD"; times are ISO instants.
export interface LeaveRequest {
  id: number;
  applicantType: LeaveApplicantType;
  facultyId: number | null;
  applicantName: string | null;
  fromDate: string;
  toDate: string;
  halfDay: LeaveHalfDay | null; // null = full day(s)
  leaveType: LeaveType;
  reason: string;
  status: LeaveStatus;
  days: number; // working days, 0.5 for a half day
  periodsAffected: number; // the faculty's timetable periods in the leave
  appliedAt: string | null;
  decidedByName: string | null;
  decidedAt: string | null;
  decisionNote: string | null;
  cancellable: boolean;
}

// POST /leave/me (faculty) and POST /leave (admin, with facultyId)
export interface LeaveApplyRequest {
  facultyId?: number;
  fromDate: string;
  toDate: string;
  halfDay: LeaveHalfDay | null;
  leaveType: LeaveType;
  reason: string;
}
